import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnDescription, columnName } from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import { deleteCohort, hideDeleteCohort } from '../actions';
import CohortsTableColumns from './CohortsTableColumns';
import CohortsTableRows from '../components/CohortsTableRows';

const CohortDeletionDialog = ({
  deleteData,
  hide,
  results,
  theme,
}) => (
  <ActionDialogContent
    className="aridhia-cohort-deletion-dialog"
    entities="cohorts"
    entity="cohort"
    hide={hide}
    icon="sitemap"
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    items={results}
    onSubmit={deleteData}
    theme={theme}
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-Cohorts-table">
        <Table.Header fullWidth>
          <CohortsTableColumns items={results} columns={[columnName, columnDescription]} />
        </Table.Header>
        <Table.Body>
          <CohortsTableRows items={results} columns={[columnName, columnDescription]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  cohorts: {
    cohorts: { deletion: { results } },
  },
}) => ({
  results,
});

const mapDispatchToProps = {
  hide: hideDeleteCohort,
  deleteData: deleteCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortDeletionDialog);
